import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import { YellowBox } from 'react-native';

YellowBox.ignoreWarnings(['Setting a timer for a long period of time']);

const firebaseConfig = {
	apiKey: 'AIzaSyD-xB4Pzz8_nLBrmrjHxWSrUVAL44dhkMg',
	authDomain: 'lshs-assured.firebaseapp.com',
	databaseURL: 'https://lshs-assured.firebaseio.com',
	projectId: 'lshs-assured',
	storageBucket: 'lshs-assured.appspot.com',
	messagingSenderId: '739306734261',
	appId: '1:739306734261:web:440fc5e8c29b0d771034fc',
	measurementId: 'G-FCCSM8C3LC',
};

export default firebase.initializeApp(firebaseConfig);
